export interface Bonus {
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    title: '🎁 BONUS 1 — Kit Operativo di Progettazione Smart Home™',
    description:
      'Schede, checklist, modelli, tabelle e strumenti per analizzare ambienti, definire esigenze, organizzare zone, scegliere protocolli, preparare materiali e costruire un progetto Smart Home prima dell’installazione.',
  },
  {
    title: '🎁 BONUS 2 — Smart Home Troubleshooting Lab™',
    description:
      'Un sistema pratico per diagnosticare problemi di pairing, connessione, Wi-Fi, Zigbee, Thread, Matter, hub, gateway, sensori, automazioni e integrazioni seguendo procedure ordinate invece di procedere per tentativi.',
  },
  {
    title: '🎁 BONUS 3 — Guida Compatibilità e Scelta Dispositivi™',
    description:
      'Criteri, matrici e checklist per valutare sensori, illuminazione, prese, relè, climatizzazione, accessi, hub e gateway verificando protocolli, compatibilità, interoperabilità ed espandibilità prima dell’acquisto.',
  },
  {
    title: '🎁 BONUS 4 — Automation Scenario Vault™',
    description:
      'Una raccolta operativa di scenari Smart Home da adattare ai tuoi progetti con obiettivi, dispositivi necessari, trigger, condizioni, azioni, configurazioni, test e varianti per comfort, sicurezza, energia e routine quotidiane.',
  },
  {
    title: '🎁 BONUS 5 — Dal Primo Progetto al Primo Cliente™',
    description:
      'Un percorso operativo per trasformare le competenze acquisite in un servizio organizzato: analisi delle esigenze, sopralluogo, definizione del progetto, proposta, materiali, configurazione, collaudo, documentazione, consegna e assistenza.',
  },
]
